import { Outlet, Navigate } from "react-router-dom";

const PrivateRoutes = () => {
  let auth = { token: localStorage.getItem("isloggedIn") };
  return auth.token === "true" ? <Outlet /> : <Navigate to="/login" />;
};

export default PrivateRoutes;
